import React, { useRef } from "react";
import wll from "../../Assets/blueWaveLeft.png";
import wrr from "../../Assets/BlueWaveRight.png";
import l1 from "../../Assets/Layer1.png";
import l2 from "../../Assets/Layer2.png";

import { useScroll, useTransform, motion } from "framer-motion";

export default function WhyChoseUs() {
  const overLay = useRef(); // Reference for the scroll container

  // Track the scroll progress
  const { scrollYProgress } = useScroll({
    target: overLay,
    offset: ["start end", "end start"], // Adjusts the scroll range
  });

  // Transform scroll progress into a rotation value
  const rotation = useTransform(scrollYProgress, [0, 1], [0, 270]); // Rotate from -8° to 7°

  return (
    <div
      ref={overLay}
      className="flex flex-col items-center relative -top-[140px] md:-top-[50px]"
    >
      <div className="md:flex md:justify-around md:items-center">
        <div>
          <img src={wll} alt="blueWaveLeft" className="hidden md:flex" />
        </div>
        <p className="text-[36px] md:text-[64px] text-center font-[700] text-[#0fbfe6] pb-2 md:py-2">
          Why Choose Us
        </p>
        <div>
          <img src={wrr} alt="BlueWaveRight" className="hidden md:flex" />
        </div>
      </div>
      <div>
        <p className="text-black">
          The Best Laundry Experience in the Industry
        </p>
      </div>

      <div className="px-5 md:px-20 relative">
        {/* Parent container set to relative */}
        {/* First div */}
        <div>
          <motion.img src={l1} alt="Layer1" className="relative top-[-30px" />
        </div>
        {/* Second div overlaying the first */}
        <div className="absolute top-[-6%] left-0 " style={{ zIndex: 10 }}>
          <motion.img
            src={l2}
            alt="Layer2"
            className="relative top-[-30px"
            style={{
              rotate: rotation,
            }}
          />
        </div>
      </div>
    </div>
  );
}
